module.exports = __webpack_public_path__ + "img/Surf@2x.10142790.png";